import type { CustomFile } from '../types';

import { isDirectoryEntry, isFileEntry } from './fileSystemEntry';
import readDirectoryEntries from './readDirectoryEntries';
import readFileEntry from './readFileEntry';
import toCustomFile from './toCustomFile';

// ----------------------------------------------------------------------------

async function traverseFileTree(entry: FileSystemEntry, path: string = ''): Promise<CustomFile[]> {
    if (isFileEntry(entry)) {
        const file = await readFileEntry(entry);
        const relativePath = path ? appendRelativePath(path, file.name, false) : undefined;

        return [toCustomFile(file, relativePath)];
    }

    if (isDirectoryEntry(entry)) {
        const entries = await readDirectoryEntries(entry);
        const nextPath = appendRelativePath(path, entry.name);
        const results = await Promise.all(
            entries.map(async (subEntry): Promise<any> => traverseFileTree(subEntry, nextPath)),
        );

        return results.flat();
    }

    throw new Error(`Unsupported entry type: ${entry.name}`);
}

// ----------------------------------------------------------------------------

function appendRelativePath(path: string, segment: string, trailingSlash: boolean = true): string {
    return trailingSlash ? `${path}${segment}/` : `${path}${segment}`;
}

// ----------------------------------------------------------------------------

export default traverseFileTree;
